import React from 'react'
import i18n from 'i18n-js'
import messages from '../../constants/messages'

i18n.fallbacks = true
i18n.translations = messages

const LocalizationContext = React.createContext()

export default LocalizationContext 
